module.exports = __webpack_public_path__ + "fonts/montserrat-black-webfont.89217c9.woff";